import { get } from "lodash";

import Form from "../types/Form";
import Question from "../types/Question";

export const MapRevisionDataToForm = (revisions: any, form: Form): Form => {
  form.questions = form.questions.map((question: Question) => {
    const valueKey = !question.scope ? question.key : [question.scope, question.key].join(".");

    question.status = get(revisions, valueKey, "approved");

    return question;
  });

  return form;
};
